import React, {ReactElement} from 'react';
import {ServiceBase} from '../ServiceBase';
import {
    IGermanyResponsibleGamingButtonOptions,
    IOrbitComponentInSdk,
    IOrbitComponentToSdkAdapterService, IOrbitDialogInSdk
} from '../../../common/interfaces/orbit-component-to-sdk-adapter/orbit-component-to-sdk-adapter.service.interface';
import {
    ITimeSpentReminderWithBalanceComponentProps,
    ITimeSpentReminderOptions
} from '../../../common/interfaces/orbit-component-to-sdk-adapter/components-props/time-spent-reminder-options';
import {IPartyJackpotInGameWidgetComponentProps} from '../../../common/interfaces/orbit-component-to-sdk-adapter/components-props/party-jackpot-ingame-widget.component-props';
import {PartyJackpotInGameWidgetComponent} from '../../components/party-jackpot-ingame-widget/party-jackpot-ingame-widget.component';
import {IShowPartyJackpotWelcomePopupOptions} from '../../../common/interfaces/orbit-component-to-sdk-adapter/components-props/show-party-jackpot-welcome-popup-options';
import {
  ResponsibleGamingButtonsGermanyComponent
} from "../../components/responsible-gaming-buttons/germany/responsible-gaming-buttons-germany.component";
import {action, observable} from 'mobx';
import {IOrbitComponentsInsideSdkProvider, IComponentRenderedInsideSdk} from './orbit-components-inside-sdk-provider.interface';
import {TimeSpentReminderWithDropdownComponent} from "../../components/time-spent-reminder/with-dropdown/time-spent-reminder-with-dropdown.component";
import {DialogButtonClickHandleResultEnum, ShowModalOptions} from "../dialog/dialog.service.interface";
import {StatePopupComponent} from "../../components/state-popup/state-popup.component";
import {IStatePopupOptions} from "../../../common/interfaces/orbit-component-to-sdk-adapter/components-props/state-popup.component-props";
import {GeoPermissionsPopupComponent} from "../../components/geo-permission-popup/geo-permission-popup.component";
import {IGeoPermissionPopupOptions} from "../../../common/interfaces/orbit-component-to-sdk-adapter/components-props/geo-permission-popup.component-props";
import {TimeSpentReminderWithBalanceComponent} from "../../components/time-spent-reminder/with-balance/time-spent-reminder-with-balance.component";
import { IdleRecommendationsComponentProps } from '../../../common/interfaces/orbit-component-to-sdk-adapter/components-props/idle-recommendations.component-props';
import { IdleRecommendationComponent } from '../../components/idle-recommendation/idle-recommendation.component';
import {
    PRIORITY_LEVEL,
    PRIORITY_LEVEL_ZINDEX_MAPPER
} from "../../../sdk/src/services/overlay_manager/overlay_manager_levels";
import {
    AboutComponent
} from "../../components/about-component/about.component";
import {
    IAboutComponentDisplayParams
} from "../../../common/interfaces/orbit-component-to-sdk-adapter/components-props/about-component-params";
import {
    INightLimitWarningPopupDisplayParams
} from "../../../common/interfaces/orbit-component-to-sdk-adapter/components-props/night-limit-warning-popup-display-params";
import {DISPLAY_MESSAGE_IDS} from "../../../common/const/casinofied-analytics-consts";

export class OrbitComponentToSdkAdapterService extends ServiceBase implements IOrbitComponentToSdkAdapterService, IOrbitComponentsInsideSdkProvider {
    renderPartyJackpotInGameWidget(element: HTMLElement, props: IPartyJackpotInGameWidgetComponentProps): IOrbitComponentInSdk {
        return this._renderComponent(element,
                <PartyJackpotInGameWidgetComponent key={'PartyJackpotInGameWidget'} {...props}/>
            );
    }
    renderGermanyResponsibleGamingButtons(element: HTMLElement, options?:IGermanyResponsibleGamingButtonOptions): IOrbitComponentInSdk{
        return this._renderComponent(element,
            <ResponsibleGamingButtonsGermanyComponent key={'GermanyResponsibleGamingButtons'} placement={options?.placement}/>);
    }

    showPartyJackpotWelcomePopup(options: IShowPartyJackpotWelcomePopupOptions): IOrbitDialogInSdk {
        return this.services.partyJackpot.showPartyJackpotWelcomePopup(options);
    }

    showLocationPopup(props: IStatePopupOptions) {
        return this.services.dialog.showModal(dialogHandler =>
                <StatePopupComponent
                    dialogHandler={dialogHandler}
                    onStateSelect={props.onStateSelect}
                    headerText={this.services.translation.translate("STATE_POPUP_HEADER", {THE_STATE: props.stateName})}
                    onStateNotInListClick={props.onStateNotInListClick}
                    stateName={props.stateName}
                />, {
                title: this.services.translation.translate("STATE_POPUP_TITLE"),
                icon: this.services.theme.currentTheme.icons.locationIcon,
                forceTransparentBackground: true,
                disableFullscreenMobile: true,
                forceCentralization: true,
                mobileCenterHeader: true,
                isHighPriority:  true,
                onClosed: props.onMessageClosed,
                shouldBeClosedOnlyByUser: true
            }
        );
    }

    showGeoPermissionPopup(props: IGeoPermissionPopupOptions) {
        return this.services.dialog.showModal(dialogHandler =>
                <GeoPermissionsPopupComponent
                    dialogHandler={dialogHandler}
                    onOkPressed={props.onOkPressed}
                    headerText1={this.services.translation.translate("GEO_PERMISSIONS_POPUP_TOP_TEXT")}
                    headerText2={this.services.translation.translate("GEO_PERMISSIONS_POPUP_MIDDLE_TEXT")}

                />, {
                title: this.services.translation.translate("GEO_PERMISSIONS_POPUP_TITLE"),
                icon: this.services.theme.currentTheme.icons.locationIcon,
                forceTransparentBackground: true,
                disableFullscreenMobile: true,
                forceCentralization: true,
                mobileCenterHeader: true,
                isHighPriority:  true,
                forceZOrder: PRIORITY_LEVEL_ZINDEX_MAPPER[PRIORITY_LEVEL.TOUCH_ID] - 1,
                onClosed: props.onMessageClosed,
                shouldBeClosedOnlyByUser: true,
                hideCloseButton: true,
            }
        );
    }

    private _getTimeSpentReminderDialogOptions(headerClass?: string): ShowModalOptions {
        return {
            title: this.services.translation.translate("TSR_TITLE"),
            forceTransparentBackground: true,
            disableFullscreenMobile: true,
            forceCentralization: true,
            mobileCenterHeader: true,
            isHighPriority:  true,
            onClosed: null,
            shouldBeClosedOnlyByUser: true,
            hideCloseButton: true,
            headerClass: headerClass,
            showPopupAboveSecondWebViewHybrid: true,
            icon: this.services.theme.currentTheme.icons.timeSpentReminderClockIcon
        };
    }

    showTimeSpentReminderWithDropdown(options: ITimeSpentReminderOptions): IOrbitDialogInSdk {

        const dialogOptions = this._getTimeSpentReminderDialogOptions('cy-uk-malta-reality-check-title');

        return this.services.dialog.showModal(dialogHandler => <TimeSpentReminderWithDropdownComponent
            {...options}
            dialogHandler={dialogHandler}/>
            , dialogOptions );
    }

    showTimeSpentReminderWithBalance(options: ITimeSpentReminderWithBalanceComponentProps): IOrbitDialogInSdk {

        const dialogOptions = this._getTimeSpentReminderDialogOptions();

        return this.services.dialog.showModal(dialogHandler => <TimeSpentReminderWithBalanceComponent
                {...options}
                dialogHandler={dialogHandler}/>
                , dialogOptions );
    }

    showAboutComponent(params: IAboutComponentDisplayParams): IOrbitDialogInSdk {
        return this.services.dialog.showModal(dialogHandler => <AboutComponent
            {...params}
            dialogHandler={dialogHandler}
        />, {
            title: this.services.translation.translate("ABOUT_TITLE"),
            forceTransparentBackground: true,
            disableFullscreenMobile: true,
            forceCentralization: true,
            mobileCenterHeader: true
        });
    }

    showNightLimitWarningPopup(params: INightLimitWarningPopupDisplayParams): IOrbitDialogInSdk {
        if(this.services.miniOrbit.isEnabled) {
            return; //We don't show the popup on our side for mini orbit
        }

        const businessCorrelationId = this.services.tools.getGuid();

        this.services.casinofiedAnalytics.messageDisplay({
            businessCorrelationID: businessCorrelationId,
            displayMessageID: DISPLAY_MESSAGE_IDS.nightLimitWarning,
            displayMessageName: 'DisruptiveWarningMessage'
        });

        const WarningIcon = this.services.theme.currentTheme.icons.warningSignIcon;
        return this.services.dialog.showSimpleTextModal({
            buttons: [
                {
                    buttonPreset: "secondary",
                    text: params.buttonText,
                    onClick: async () => {
                        this.services.casinofiedAnalytics.messageActionTaken({
                            actionType: 'Confirmation',
                            businessCorrelationID: businessCorrelationId
                        });
                        return DialogButtonClickHandleResultEnum.CloseDialogAndContinue;
                    }
                }
            ],
            hideCloseButton: true,
            text: params.text,
            title: params.title.toLowerCase(),
            icon: <WarningIcon style={{display: "inline"}} size={5.6}/>,
            disableFullscreenMobile: true,
            showPopupAboveSecondWebViewHybrid: true
        })
    }

    renderIdleRecommendations(element: HTMLElement, props: IdleRecommendationsComponentProps): IOrbitComponentInSdk {
        return this._renderComponent(element,
                <IdleRecommendationComponent key={'IdleRecommendation'} {...props}/>
            );
    }

    @observable.ref currentRenderedComponents: IComponentRenderedInsideSdk[] = [];

    @action
    private _setCurrentRenderedComponents(currentRenderedComponents: IComponentRenderedInsideSdk[]) {
        this.currentRenderedComponents = currentRenderedComponents;
    }

    private _unmountComponent(element: HTMLElement) {
        const index = this.currentRenderedComponents.findIndex(item => item.element === element);
        if(index >= 0) {
            this._setCurrentRenderedComponents([...this.currentRenderedComponents.splice(index, 1)])
        }
    }

    private _renderComponent(element: HTMLElement, component: ReactElement): IOrbitComponentInSdk {

        this._setCurrentRenderedComponents([
            ...this.currentRenderedComponents,
            {
                component: component,
                element: element
            }
        ]);

        return {
            unmount: () => {
                this._unmountComponent(element)
            }
        }
    }

}